import { ContentInterface, LinkInterface, LinkType } from '.';

export class Link implements LinkInterface, ContentInterface {
  private readonly _link: LinkInterface;

  constructor(link: LinkInterface) {
    this._link = link;
  }

  get id(): number {
    return this._link.id;
  }

  get type(): LinkType {
    return this._link.type;
  }

  get name(): string {
    return this._link.name;
  }

  get fileExtension(): string {
    return 'link';
  }

  get description(): string {
    return this._link.label;
  }

  get link(): string {
    return this._link.url;
  }

  get url(): string {
    return this.link;
  }
}
